import React from "react";

const ImageModal = ({ isOpen, onClose, imageURL, alt }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e:any) => {
    if (e.target === e.currentTarget) {
      onClose(e);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-70 p-5 flex items-center justify-center z-50"
      onClick={handleOverlayClick}
    >
      <div className="relative">
        <img
          src={imageURL}
          alt={alt}
          onClick={handleOverlayClick}
          className="max-w-full max-h-[90vh] object-contain rounded-lg"
        />
      </div>
    </div>
  );
};

export default ImageModal;
